import { useProfileManager } from '@/shared/hooks/useProfileManager';

export function useUserIdMenuQueryParams() {
    const profileManager = useProfileManager();

    const queryParams: Record<string, string> = {};

    if (profileManager.userProfile?.badges?.golden) {
        queryParams['allplay.crown'] = '1';
    }

    return queryParams;
}
